import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import { createSession, getSession } from "../../utils/session";
import ShipexLogo from '../../assets/Shipex.jpg'; // adjust path as needed
import illustrationimage from '../../assets/Login.png'; // adjust path as needed

const LoginPage = ({ setIsAuthenticated }) => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState({});
  const [message, setMessage] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  // console.log(",ddddddd",REACT_APP_BACKEND_URL)

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    const initialize = async () => {
      try {
        const param = new URLSearchParams(window.location.search);
        const token = param.get("token");

        if (token) createSession(token);

        const response = await getSession();
        if (response?.success) {
          setIsAuthenticated(true);
        }
      } catch (err) {
        console.error("Error during session initialization", err);
      }
    };
    initialize();
  }, [setIsAuthenticated]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;

    setError({});
    setMessage(null);

    const newErrors = {};
    if (!email) newErrors.email = "Email is required";
    if (!validateEmail(email)) newErrors.email = "Invalid email address";
    if (!password) newErrors.password = "Password is required";
    if (password.length < 8)
      newErrors.password = "At least 8 characters required";

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return;
    }

    try {
      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/external/login`,
        { email, password }
      );

      if (response?.data?.success) {
        console.log("response", response.data);
        localStorage.setItem("kyc", response.data.kyc)
        setMessage(response.data.message);
        createSession(response.data.data);
        setIsAuthenticated(true);
        localStorage.removeItem("activeNdrTab"); // or whatever your token key is
        localStorage.removeItem("activeOrderTab");
        localStorage.removeItem("activeUserDiscrepancyTab");
        localStorage.removeItem("activeDiscrepancyTab");
        localStorage.removeItem("activeSidebarItem");
        console.log("ress", response.data)
        // navigate("/dashboard");
      } else {
        setMessage(response?.data?.message || "Invalid login attempt");
      }
    } catch (err) {
      setMessage(
        err?.response?.data?.message ||
        "An error occurred. Please try again later."
      );
    }
  };

  return (
    <div className="flex flex-col min-h-screen overflow-hidden ">
      {/* Main Content */}
      <div className="flex flex-col md:flex-row bg-green-50 flex-grow">
        {/* Left Section */}
      <div className="w-full px-4 py-6 md:p-6 flex justify-center items-center">
  <div className="w-full max-w-sm md:max-w-md p-4  md:p-6 rounded-lg shadow-sm bg-white  ">
    {/* Logo */}
    <div className="flex justify-start mb-4 md:mb-6">
      <img src={ShipexLogo} alt="Logo" className="h-10 md:h-12" />
    </div>

    {/* Heading */}
    <h1 className="text-xl md:text-3xl font-bold mb-2 md:mb-3 text-left text-[#0CBB7D]">
      Welcome Back!
    </h1>
    <p className="text-gray-600 mb-4 text-sm md:text-[12px] font-normal">
      Enter your credentials to access your account
    </p>

    {/* Error Message */}
    {message && (
      <p className="text-left text-sm text-red-500 mb-4">{message}</p>
    )}

    {/* Form */}
   <form className="space-y-4" onSubmit={handleSubmit}>
  {/* Email Field */}
  <div>
    <label className="block text-gray-700 text-[12px] font-medium">
      Email
    </label>
    <input
      type="email"
      name="email"
      placeholder="Enter Email"
      value={formData.email}
      onChange={handleChange}
      className="border rounded-lg p-2 w-full text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
    />
    {error.email && (
      <p className="text-[12px] text-red-500 mt-1">{error.email}</p>
    )}
  </div>

  {/* Password Field */}
  <div>
    <label className="block text-gray-700 text-[12px] font-medium flex justify-between items-center">
      <span>Password</span>
      <Link
        to="/ForgotPassword"
        className="text-[12px] text-[#0CBB7D] hover:underline"
      >
        Forgot Password?
      </Link>
    </label>
    <div className="relative">
      <input
        type={showPassword ? "text" : "password"}
        name="password"
        placeholder="Password"
        value={formData.password}
        onChange={handleChange}
        className="border rounded-lg p-2 w-full pr-10 text-[12px] outline-none focus:ring-1 focus:ring-[#0CBB7D]"
      />
      <span
        onClick={togglePasswordVisibility}
        className="absolute right-3 top-2.5 cursor-pointer text-[#0CBB7D]"
      >
        {showPassword ? <FaEye /> : <FaEyeSlash />}
      </span>
    </div>
    {error.password && (
      <p className="text-[12px] text-red-500 mt-1">{error.password}</p>
    )}
  </div>

  {/* Remember Me */}
  <div className="flex items-center space-x-2">
    <input type="checkbox" className="h-4 w-4 text-[#0CBB7D]" />
    <p className="text-[12px] font-normal text-gray-700">Remember me</p>
  </div>

  {/* Login Button */}
  <button
    type="submit"
    className="bg-[#0CBB7D] text-white py-2 text-[12px] font-medium px-3 rounded-lg w-full mt-4 hover:bg-opacity-90 transition"
  >
    Log In
  </button>

  {/* Signup Link */}
  <p className="text-[12px] font-normal text-gray-700 text-left mt-3">
    New to ShipexIndia?{" "}
    <Link
      to="/register"
      className="text-[#0CBB7D] underline hover:text-[#0CBB7D]"
    >
      Create new account
    </Link>
  </p>
</form>

  </div>
</div>


        {/* Right Section - Image (only on larger screens) */}
        {/* Right Section - Exact Styled Circular Steps */}
{/* Exact Circular Steps Design */}
<div className="flex justify-center items-center mt-36 hidden md:block">
  <div className="relative w-[350px] h-[350px] flex items-center justify-center md:mr-60 mr-0 md:scale-100 scale-[0.65]">
    
    {/* Outer Dashed Circle */}
    <div className="absolute w-full h-full rounded-full border-2 border-dashed border-black" />

    {/* Inner Light Circle with Center Text */}
    <div className="w-[180px] h-[180px] rounded-full border border-bg-[#0CBB7D] bg-white flex items-center justify-center text-center px-4">
      <p className="text-[14px] font-semibold text-gray-900 leading-snug">
        Start shipping<br />in 3 easy steps
      </p>
    </div>

    {/* Step 1 - Top */}
    <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 text-center">
      <p className="text-[13px] text-black -mt-7 font-medium">Sign Up</p>
      <div className="bg-[#0CBB7D] text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm shadow-md mt-3">1</div>
    </div>

    {/* Step 2 - Right (FIXED ALIGNMENT) */}
    <div className="absolute top-1/2 right-[-40px] transform -translate-y-1/2 text-center">
      <div className="flex flex-row items-center -ml-[70px]">
        <div className="bg-[#0CBB7D] text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm shadow-md ml-2">
          2
        </div>
        <p className="text-[13px] text-black mt-4 ml-3 font-medium leading-snug text-center -mr-32">
          Complete Your<br />Kyc
        </p>
      </div>
    </div>

    {/* Step 3 - Bottom */}
    <div className="absolute -bottom-14 left-1/2 transform -translate-x-1/2 text-center w-28">
      <div className="bg-[#0CBB7D] text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm shadow-md mx-auto">3</div>
      <p className="text-[13px] text-black mt-1 font-medium leading-snug">
        Recharge Your<br />Account
      </p>
    </div>

    {/* Step 4 - Left (FIXED ALIGNMENT) */}
    <div className="absolute top-1/2 -left-11 transform -translate-y-1/2 text-center">
      <div className="flex flex-row items-center -ml-[70px]">
        <p className="text-[13px] text-black mt-0 font-medium leading-snug text-center mr-3">
          Start Shipping
        </p>
        <div className="bg-[#0CBB7D] text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm shadow-md mx-auto">
          4
        </div>
      </div>
    </div>

  </div>
</div>
      </div>  

      {/* Footer */}
    <div className="w-full bg-white ">
  <footer className="w-full bg-green-50 px-4 py-4 flex flex-col sm:flex-row sm:justify-between sm:items-center text-gray-500 text-[12px] text-center sm:text-left space-y-2 sm:space-y-0 ">
    <p className="w-full sm:w-auto font-normal">
      © 2025 Shipex. All rights reserved.
    </p>

    <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-1 sm:space-y-0 w-full sm:w-auto hidden md:block">
      <a href="#" className="text-gray-500 hover:text-gray-900">
        Privacy Policy
      </a>
      <a href="#" className="text-gray-500 hover:text-gray-900">
        Refund & Cancellation Policy
      </a>
      <a href="#" className="text-gray-500 hover:text-gray-900">
        Terms & Conditions
      </a>
    </div>
  </footer>
</div>

    </div>
  );
};

export default LoginPage;
